const key = 'hizmetler';

export const saveHizmet = (kulModelKodu, data) => {
  try {
    const hizmetObj = {
      KUL_MODEL_KODU: kulModelKodu,
      DATE: new Date(),
      DATA: data
    };
    let hizmetler = loadHizmetler();
    hizmetler = [...hizmetler, hizmetObj];
    localStorage.removeItem(key);
    localStorage.setItem(key, JSON.stringify(hizmetler));
  } catch (error) {}
};

// Modele ait hizmetleri kontrol eder. Tarih aynı gün değilse siler ve boş döner. Değilse, hizmet datasını döner.
export const loadHizmet = kulModelKodu => {
  try {
    const hizmetler = loadHizmetler();
    const filtered = hizmetler.filter(h => h.KUL_MODEL_KODU === kulModelKodu);
    if (filtered.length === 0) {
      // localde yok. Return empty.
      return [];
    }
    if (filtered.length > 1) {
      // aynı modele ait birden fazla hizmet verisi olamaz. Something is wrong!. Clear locale data and return empty.
      removeHizmet(kulModelKodu);
      return [];
    }
    const hizmet = filtered[0];
    const now = new Date();
    const ld = new Date(hizmet.DATE); // Last Date
    if (
      now.getYear() === ld.getYear() &&
      now.getMonth() === ld.getMonth() &&
      now.getDate() === ld.getDate()
    ) {
      return hizmet.DATA;
    }
    removeHizmet(kulModelKodu);
    return [];
  } catch (error) {
    return [];
  }
};

export const checkHizmet = kulModelKodu => {
  try {
    const hizmetler = loadHizmetler();
    const filtered = hizmetler.filter(h => h.KUL_MODEL_KODU === kulModelKodu);
    return filtered.length !== 0;
  } catch (error) {
    return false;
  }
};

// /////////// HELPER METHODS (NOT EXPORTED) /////////////////////

// localstorage'daki tüm hizmetleri getirir.
const loadHizmetler = () => {
  try {
    let hizmetlerTxt = localStorage.getItem(key);
    if (hizmetlerTxt === null) {
      localStorage.setItem(key, '[]');
      hizmetlerTxt = '[]';
    }
    return JSON.parse(hizmetlerTxt);
  } catch (error) {
    return [];
  }
};

// Modele ait tüm hizmetler local storage'dan silinir.
const removeHizmet = kulModelKodu => {
  try {
    const hizmetler = loadHizmetler();
    const otherHizmetler = hizmetler.filter(
      h => h.KUL_MODEL_KODU !== kulModelKodu
    );
    localStorage.setItem(key, JSON.stringify(otherHizmetler));
    return true;
  } catch (error) {
    return false;
  }
};
